import { render, staticRenderFns } from "./ItemLabel.vue?vue&type=template&id=74b49925&scoped=true&"
import script from "./ItemLabel.vue?vue&type=script&lang=js&"
export * from "./ItemLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b49925",
  null
  
)

export default component.exports